import { FullTransferTokenInfo } from '../../../types/SharedTransfer.types';

export const getInvalidTransfers = (transfers: FullTransferTokenInfo[]): FullTransferTokenInfo[] =>
    transfers.filter((transfer) => transfer.validationResult.status !== 'success');
